import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

export const firebaseConfig = {
  apiKey: "AIzaSyAZIKY8nW8F-0Sd27jk8NNPaM9nANyT2gA",
  authDomain: "earthpbc-explorer.firebaseapp.com",
  databaseURL: "https://earthpbc-explorer.firebaseio.com",
  projectId: "earthpbc-explorer",
  storageBucket: "earthpbc-explorer.appspot.com",
  messagingSenderId: "702641111945",
  appId: "1:702641111945:web:b4901b51900b3b9f5f9758",
  measurementId: "G-770E0BMBY1"
}

// Initialize Firebase app
const app = initializeApp(firebaseConfig)

// Export auth instance
export const auth = getAuth(app)

// Legacy export for backward compatibility (will be removed gradually)
export default {
  auth,
}
